import { SAMPLE_CONTACTS } from './sampleContacts';
import type { AccountContact } from './types';

// Same shape as the other Account list hooks, so wiring svc-contracting only replaces this body.
export function useAccountContacts(_accountId: string): {
  contacts: ReadonlyArray<AccountContact>;
  error: Error | null;
  isLoading: boolean;
} {
  return { contacts: SAMPLE_CONTACTS, error: null, isLoading: false };
}
